var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-button',{staticClass:"logout",attrs:{"icon":"@assets/icon-logout.svg","title":"Выйти из учётной записи"},on:{"click":_vm.logout}})}
var staticRenderFns = []

export { render, staticRenderFns }